<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
export default {
  components: { ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Hotel Booking List",
      items: [
        {
          text: "Hotel Booking",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      admins: [],
        alladmins:[],
        display_div:true,
      pin: "",
      bookings: [],
      user_id: "",
      booking_startdate: "",
      booking_enddate: "",
        booking_status:"",
        destination:"",
      remarks: "",
        user_type:"",
      errors: null,
        visible:false,
        message:"",
        search1:"",
        booking_statuses:[],
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_ref_key:"",
        search_account_type:"",
        search_target_api:"",
        search_check_in:"",
        search_check_out:"",
        search_contact_phone:"",
        search_contact_email:"",

    };
  },
    created() {
       this.booking_status=this.$route.params.status;
    },
  mounted() {
    this.getAdminList();
    this.getBookingStatuses();
    this.search();
  },
    computed: {
        filteredList() {
            return this.bookings.filter(booking => {
                return booking.search_reference_key.toLowerCase().includes(this.search_ref_key.toLowerCase())
                    && (booking.user.first_name==null ? '' : booking.user.first_name).toLowerCase().includes(this.search_fname.toLowerCase())
                    || (booking.user.last_name==null ? '' : booking.user.last_name).toLowerCase().includes(this.search_fname.toLowerCase())
                    && (booking.user.username==null ? '' : booking.user.username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && booking.api_vendor.api_provider.toLowerCase().includes(this.search_target_api.toLowerCase())
                    && (booking.contact_phone_number==null ? '' : booking.contact_phone_number).includes(this.search_contact_phone)
                    && (booking.contact_email==null ? '' : booking.contact_email).toLowerCase().includes(this.search_contact_email.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search1=val;
        },
        toggleDiv: function() {
            this.display_div = !this.display_div;
        },
    async getAdminList() {
      try {
        axios
          .get("/api/user/approved/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }
                    if(temp[i].account_type=='b2c'){
                        if(temp[i].first_name==null){
                            temp[i].text=temp[i].email + '(unregistered)';
                        }else{
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                        }
                        temp[i].value = temp[i].id;
                        arr.push(temp[i]);
                    }

                }
                this.alladmins=arr;
                this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
        async getBookingStatuses() {
            try {
                axios
                    .get("/api/flight-booking/statuses", {
                        params: {
                            accessToken: localStorage.getItem("access_tocken"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking_statuses = response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
    async search() {
      try {
        axios
          .get("/api/hotel-booking", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              user_id: this.user_id,
              booking_startdate: this.booking_startdate,
                booking_enddate: this.booking_enddate,
                user_type:this.user_type,
                booking_status:this.booking_status,
                destination:this.destination,
            },
          })
          .then((response) => {
            if (response.data.status) {
                this.bookings=response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async clear() {
          this.user_type="";
          this.user_id="";
              this.booking_startdate="";
              this.booking_enddate="";
          this.booking_startdate="";
          this.booking_enddate="";
          this.booking_status="";
          this.destination="";
          this.admins=this.alladmins;
      },
        onChange(event) {
            this.user_type=event.target.value;
            var temp=this.alladmins;
            var arr=[];
            var i;
            for (i=0;i<temp.length;i++){
                if (temp[i].account_type==event.target.value){
                    arr.push(temp[i]);
                }
            }
            this.admins = arr;
        },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <h4 class="card-title">Hotel Booking List</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select User</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
<!--                  <select-->
<!--                    id="user_id"-->
<!--                    name="user_id"-->
<!--                    v-model="user_id"-->
<!--                    class="form-control"-->
<!--                    placeholder="Type Select User">-->
<!--                    <option v-for="(admin, index) in admins" :value="admin.id" v-if="admin.account_type == user_type"-->
<!--                          v-bind:key="index">{{ admin.first_name+' '+admin.last_name }}-->
<!--                  </option>-->
<!--                  </select>-->
                </div>
              </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="booking_status">Select Status</label>
                        <select
                            id="booking_status"
                            name="booking_status"
                            v-model="booking_status"
                            class="form-control"
                            placeholder="Type Status">
                            <option v-for="(status, index) in booking_statuses" :value="status.status_tag"
                                    v-bind:key="index">{{ status.status_name }}
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div>
                  <label for="start-datepicker1">Booking Start Date</label>
                  <b-form-datepicker id="start-datepicker1" v-model="booking_startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="end-datepicker1">Booking End Date</label>
                  <b-form-datepicker id="end-datepicker1" v-model="booking_enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="destination">Destination</label>
                        <input
                            id="destination"
                            v-model="destination"
                            name="destination"
                            type="text"
                            class="form-control"
                            placeholder="Type Ticket No."
                        />
                    </div>
                </div>
              <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Booking List</h4>
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                      <th>Search Ref key</th>
                      <th>Name</th>
                      <th>User Name</th>
                    <th>Target API</th>
                    <th>Total Guests</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                      <th>Rooms</th>
                      <th>Nights</th>
                      <th>Booking Status</th>
                      <th>Payment Status</th>
                      <th>Base Fare</th>
                      <th>Total Tax</th>
                      <th>Gross Fare</th>
                      <th>Invoice Fare</th>
                      <th>Commission</th>
                      <th>Markup</th>
                      <th>Hotel Name</th>
                      <th>Address</th>
                      <th>Region</th>
                      <th>Country Code</th>
                      <th>Refundable</th>
                      <th>Cancellation Fee</th>
                      <th>Contact Email</th>
                      <th>Contact Phone</th>
                      <th>Action</th>
                  </tr>
                  <tr>
                    <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_ref_key" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_fname" placeholder="Search " /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_target_api" placeholder="Search " /></td>
                    <td> &nbsp </td>
                      <td> &nbsp </td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_target_api" placeholder="Search " /></td>-->
                      <td> &nbsp </td>
<!--                      <td><input type="text" class="app-search form-control" v-model="search_check_in" placeholder="Search " /></td>-->
<!--                      <td><input type="text" class="app-search form-control" v-model="search_check_out" placeholder="Search " /></td>-->
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_contact_email" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_contact_phone" placeholder="Search " /></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(booking,index) in filteredList"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td>{{booking.search_reference_key==null ? 'N/A' : booking.search_reference_key }}</td>
                      <td v-if="booking.user!=null">{{booking.user.first_name+" "+booking.user.last_name+"("+booking.user.account_type+")"}}</td>
                      <td v-else>No user</td>
<!--                      <td v-if="booking.user!=null">{{booking.user.last_name}}</td>-->
<!--                      <td v-else>N/A</td>-->
                      <td v-if="booking.user!=null">{{booking.user.username==null?'N/A':booking.user.username}}</td>
                      <td v-else>No user</td>
<!--                      <td v-if="booking.user!=null">{{booking.user.account_type}}</td>-->
<!--                      <td v-else>No user</td>-->
                    <td>{{booking.api_vendor.api_provider}}</td>
                    <td>{{booking.total_number_of_guest}}</td>
                    <td>{{booking.check_in==null?'N/A':booking.check_in | moment('ll')}}</td>
                    <td>{{booking.check_out==null?'N/A':booking.check_out | moment('ll')}}</td>
                      <td>{{booking.no_of_room}}</td>
                      <td>{{booking.no_of_night_stay}}</td>
                      <td>{{booking.booking_status.status_name}}</td>
                      <td v-if="booking.payment_status==0">Pending</td>
                      <td v-else>Confirmed</td>
                    <td>{{booking.base_fare}}</td>
                      <td>{{booking.total_tax}}</td>
                      <td>{{booking.total_fare}}</td>
                      <td>{{booking.invoice_fare}}</td>
                      <td v-if="booking.commission!=null">{{booking.commission}}</td><td v-else>no</td>
                      <td v-if="booking.markup!=null">{{booking.markup}}</td><td v-else>no</td>
                      <td>{{booking.hotel_name}}</td>
                      <td>{{booking.street_address}}</td>
                      <td>{{booking.region}}</td>
                      <td>{{booking.country_code}}</td>
                      <td v-if="booking.is_refundable==0">No</td>
                      <td v-else>Yes</td>
                      <td>{{booking.cancellation_fee}}</td>
                      <td>{{booking.contact_email}}</td>
                      <td>{{booking.contact_phone_number}}</td>
                      <td><router-link :to="{ name: 'hotel_booking_update', params: {id: booking.id } }" class="btn btn-primary btn-sm" ><i class="fas fa-edit"></i> Edit</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
#start-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#start-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
</style>
